import styled from '@emotion/styled';
import { BREAKPOINTS } from '@ordermentum/ui-constants';

const cardString = `
background: white;
margin: auto;
position: relative;`;

const Card = styled('div')(cardString);

const CardFixedWidth = styled('div')(
  cardString.concat(`
  max-width: 50rem;
  min-width: 40rem;

  @media (max-width: ${BREAKPOINTS.TABLET_MIN}) {
    min-width: 30rem;
  }

  @media (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    min-width: 0;
    width: auto;
  };
`)
);

export { Card, CardFixedWidth };
